import router from '../router'
import hosts from '../hosts'
import util from './util'

function jumpHttpsUrl(data) {
    window.location.href = util.jointParam(data)
}

function jumpPath(param) {
    let url = ''
    switch (param.model) {
        case 'userCenter':
            switch (param.view) {
                case 'myAddress': // 收获地址
                    router.push({
                        name: "AddressList",
                        query: param.options
                    })
                    break;
                case 'helpCenter': // 帮助中心
                    url = `${hosts.getHosts().h5Host}/wxapp/helpCenter`
                    jumpHttpsUrl(url)
                    break;
                case 'productCouponActivity': // 我的礼券
                    url = `${hosts.getHosts().h5Host}/wxapp/userCoupons`
                    jumpHttpsUrl(url)
                    break;
                default:
                    console.log(`userCenter/${param.view}`)
            }
            break;
        case 'vip':
            switch (param.view) {
                case 'vipRecharge':
                    router.push({ name: "vip" })
                    break;
                default:
                    console.log(`vip/${param.view}`)
            }
            break;
        default:
            console.log(`${param.model}`)
    }
}
export default {
    jumpPath: jumpPath
}


// WEBPACK FOOTER //
// ./src/utils/skipManager.js